import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { actionSvgs, callbackSvgs } from 'assets/icons';

import ExportUser from '../ExportUser';

import * as S from './styles';

function EmployeesTable({ employees }) {
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [openExportModal, setOpenExportModal] = useState(false);

  const handleExport = employee => {
    setOpenExportModal(true);
    setSelectedEmployee(employee);
  };

  return (
    <>
      {openExportModal && (
        <ExportUser
          setIsVisible={setOpenExportModal}
          isVisible={openExportModal}
          employee={selectedEmployee}
        />
      )}

      <S.Table>
        <div className="table-responsive">
          {!employees.length ? (
            <S.Callback>
              {callbackSvgs('interrogationWoman')}
              <S.CallbackText>
                Não foram encontrados resultados para esta pesquisa. Por favor,
                tente novamente
              </S.CallbackText>
            </S.Callback>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Empresa</th>
                  <th scope="col">Nº Matrícula</th>
                  <th scope="col">Nome do funcionário</th>
                  <th scope="col">Função exercida</th>
                  <th scope="col">Senioridade</th>
                  <th scope="col">Ações</th>
                </tr>
              </thead>
              <tbody>
                {employees.map(employee => (
                  <tr key={employee.id_funcionario}>
                    <td>{employee.nome_empresa}</td>
                    <td>{employee.matricula}</td>
                    <td>{employee.nome}</td>
                    <td>{employee.nome_funcao}</td>
                    <td>{employee.senioridade}</td>
                    <td>
                      <S.EditEmployee
                        to={{
                          pathname: 'employees/edit-employee',
                          state: {
                            ...employee,
                            bate_ponto:
                              employee?.bate_ponto &&
                              typeof employee?.bate_ponto === 'number'
                                ? employee?.bate_ponto
                                : Number(
                                    String(employee?.bate_ponto)?.slice(
                                      String(employee?.bate_ponto).length - 2,
                                      String(employee?.bate_ponto).length - 1,
                                    ),
                                  ),
                          },
                        }}
                      >
                        {actionSvgs('edit')}
                      </S.EditEmployee>
                      <button
                        type="button"
                        onClick={() => handleExport(employee)}
                      >
                        {actionSvgs('newWindow')}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </S.Table>
    </>
  );
}

EmployeesTable.defaultProps = {
  employees: [],
};

EmployeesTable.propTypes = {
  employees: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ),
};

export default EmployeesTable;
